module.exports = __webpack_public_path__ + "media/images/vr/promo-multijugador-section-bg-m-2228b8f388b829c8f799869159dbe487.jpg";